import { ObjectHelper } from "@calaosoft/osapp-common/utils/helpers/objectHelper";

export class DeletedConversationError extends Error {
	constructor() {
		super(`La conversation a été supprimée.`);
		// Nécessaire pour que le 'instanceof DeletedConversationError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, DeletedConversationError);
	}
}
